import React from 'react';
import { useSelector } from 'react-redux';
import { getClassLabelKey } from '../../../../utils/utils';
import classes from './ContestTab.module.css';

const ContestTab = ({ contest, isActive, onClick }) => {

  const { texts, lang } = useSelector(state => state.translate);
  const logoUrl = contest.contestLogo?.replace('{lang}', lang || 'he');

  return (
    <button className={`${classes.contestTab} ${isActive ? classes.active : ''}`} onClick={onClick}>
      {logoUrl &&
        <img src={logoUrl} alt={contest.contestName} className={classes.contestLogo} />
      }
      <div className={classes.contestClasses}>
        {texts?.classes}
        <p className={classes.classesNumbers}>{`${texts[getClassLabelKey(contest.fromClass)]} - ${texts[getClassLabelKey(contest.toClass)]}`}</p>
      </div>
    </button>
  );
};

export default ContestTab;
